<template>
	<div class="editting mb30" v-if="show">

		<div class="row-24">
			<div class="row-12">
				<label class="label">项目名称</label>
				<input type="text" class="base-input-lg" maxlength="30" v-model="dataSource.projectName">
				<p class="error-tips" v-show="noProjectName">请输入项目名称</p>
			</div>

			<div class="row-12">
				<label class="label">担任职务</label>
				<input type="text" class="base-input-lg" maxlength="20" v-model="dataSource.jobTitle">
				<p class="error-tips" v-show="noJobTitle">请输入您在项目中担任的职务</p>
			</div>
		</div>

		<div class="row-24-block">
			<label class="label">项目时间</label>
			<div class="time-range-block cf">
				<el-date-picker type="year" class="mini-input" :clearable="false" prefix-icon="hidethisicon" value-format="yyyy" v-model="dataSource.startYear"></el-date-picker>
				<span class="unit-span">年</span>
				<el-date-picker type="month" format="MM" value-format="MM" :default-value="dataSource.startYear" class="mini-input mini-input-month" :clearable="false" prefix-icon="hidethisicon" v-model='dataSource.startMonth'></el-date-picker>
				<span class="unit-span">月</span>
				<div class="split-line cf"></div>
				<el-date-picker type="year" class="mini-input" :disabled="dataSource.isNotYet" :clearable="false" prefix-icon="hidethisicon" value-format="yyyy" v-model='dataSource.endYear'></el-date-picker>
				<span class="unit-span">年</span>
				<el-date-picker type="month" format="MM" value-format="MM" :default-value="dataSource.endYear" class="mini-input mini-input-month" :clearable="false" prefix-icon="hidethisicon" :disabled="dataSource.isNotYet" v-model='dataSource.endMonth'></el-date-picker>
				<span class="unit-span">月</span>

				<div class="not-yet">
					<input type="checkbox" name="keepsecret" v-model='dataSource.isNotYet' />

					<div class="fake-checker" @click="setEndTimeDisabled">
						<img src="../../assets/img/common/icon-circle-hollow.png" v-if="!dataSource.isNotYet" />
						<img src="../../assets/img/common/icon-circle-tick.png" v-if="dataSource.isNotYet" />
					</div>
					<span>至今</span>
				</div>
			</div>
			<p class="error-tips" v-show="timeError" v-text="timeErrorTips"></p>
		</div>

		<div class="row-24-block">
			<label class="label">项目职责</label>
			<textarea name="" class="base-textarea" placeholder="请填写" v-model="dataSource.duty" maxlength="1500"></textarea>
			<p class="error-tips" v-show="noDuty">请完善您的项目职责</p>
		</div>

		<div class="row-24-block">
			<label class="label">项目业绩</label>
			<textarea name="" class="base-textarea" placeholder="请填写" v-model="dataSource.performance" maxlength="1500"></textarea>
			<p class="error-tips" v-show="noPerformance">请完善您的项目业绩</p>
		</div>

		<!--新增-->
		<div class="row-24-block no-mb" v-if="type==='add'">
			<a href="javascript:;" class="btn-operation btn-save" @click="resumeEducationalBackgroundAddSave">保存</a>
			<a href="javascript:;" class="btn-operation btn-cancel" @click="resumeEducationalBackgroundAddCancel">取消</a>
		</div>
		<!--编辑-->
		<div class="row-24-block no-mb" v-if="type==='edit'">
			<a href="javascript:;" class="btn-operation btn-save" @click="resumeEducationalBackgroundAEditSave">保存</a>
			<a href="javascript:;" class="btn-operation btn-cancel" @click="resumeEducationalBackgroundEditCancel">取消</a>
		</div>

	</div>
</template>

<script>
	import { httpResumeProjectExperienceAdd, httpResumeProjectExperienceEdit } from '@/api/resume'
	export default {
		name: 'ResumeProjectModal',
		props: {
			tempObj: {
				type: Object,
				required: true,
			},
			show: {
				type: Boolean,
				required: true,
			},
			resumeId: {
				required: true,
			},
			type: {
				required: true,
			}
		},
		data() {
			return {
				dataSource: {
					id: 0,
					projectName: '',
					jobTitle: '',
					startYear: '',
					startMonth: '',
					endYear: '',
					endMonth: '',
					isNotYet: false,
					duty: '',
					performance: ''
				},
				noProjectName: false,
				noJobTitle: false,
				timeError: false,
				timeErrorTips: '',
				noDuty: false,
				noPerformance: false,
			}
		},
		mounted() {
			this.setDataSouce();
		},
		methods: {
			//保存简历新增
			resumeEducationalBackgroundAddSave() {
				const oData = this.buildData(); //发送的数据对象
				const canISubmit = this.checkSubmitData();
				if(!canISubmit) return;

				httpResumeProjectExperienceAdd(oData).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '新增成功',
							duration: 1200,
						})
						this.$emit('add-done');
					} else {
						console.log(r);
						this.$message.error('保存失败，请稍后再试。');
					}
				}).catch(err => {
					console.log(err);
					this.$message.error('保存失败，请稍后再试。');
				});
			},

			//取消新增
			resumeEducationalBackgroundAddCancel() {
				this.setDataSouce();
				this.$emit('add-cancel');
			},

			//保存简历的编辑
			resumeEducationalBackgroundAEditSave() {
				const oData = this.buildData(); //发送的数据对象
				const canISubmit = this.checkSubmitData();
				if(!canISubmit) return;

				httpResumeProjectExperienceEdit(oData).then(r => {
					console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '修改成功',
							duration: 1200,
						})
						this.$emit('edit-done'); //告诉父组件我编辑完了
						this.resetData();
					} else {
						console.log(r);
						this.$message.error('保存编辑失败，请您稍后再试！');
					}

				}).catch(err => {
					console.log(err);
					this.$message.error('保存编辑失败，请您稍后再试！');
				});

			},

			resetData() {
				const tempObj = {
					id: 0,
					projectName: '',
					jobTitle: '',
					startYear: '',
					startMonth: '',
					endYear: '',
					endMonth: '',
					isNotYet: false,
					duty: '',
					performance: ''
				};
				this.dataSource = JSON.parse(JSON.stringify(tempObj));
			},

			//组装请求所需要的数据
			buildData() {
				let dateTo;
				let cur_date;
				let d = new Date();
				let year = d.getFullYear();
				let month = d.getMonth() + 1;
				dateTo = year + "-" + month;
				cur_date = year + "-" + month;

				if(this.dataSource.isNotYet) {
					this.dataSource.endYear = year.toString();
					this.dataSource.endMonth = month.toString();
				}

				let oData = {
					resumeId: this.resumeId,
					id: this.dataSource.id || 0,
					projectName: this.dataSource.projectName,
					jobTitle: this.dataSource.jobTitle,
					dateFrom: this.dataSource.startYear.toString() + "-" + this.dataSource.startMonth.toString(),
					dateTo: this.dataSource.isNotYet ? cur_date : (this.dataSource.endYear + "-" + this.dataSource.endMonth),
					isCurrent: this.dataSource.isNotYet,
					duty: this.dataSource.duty,
					performance: this.dataSource.performance,
				};
				return oData;
			},

			//检查提交数据是否合法
			checkSubmitData() {

				if(!this.dataSource.projectName) {
					this.noProjectName = true;
					return false;
				} else {
					this.noProjectName = false;
				}

				if(!this.dataSource.jobTitle) {
					this.noJobTitle = true;
					return false;
				} else {
					this.noJobTitle = false;
				}

				if(!this.dataSource.startYear || !this.dataSource.startMonth) {
					this.timeError = true;
					this.timeErrorTips = '请完善项目时间'
					return false;
				} else {
					this.timeError = false;
				}

				if((!this.dataSource.endYear || !this.dataSource.endMonth) && !this.dataSource.isNotYet) {
					this.timeError = true;
					this.timeErrorTips = '请完善项目时间'
					return false;
				} else {
					this.timeError = false;
				}

				if(this.dataSource.endYear && !this.dataSource.isNotYet) {
					if(this.dataSource.endYear < this.dataSource.startYear) {
						this.timeError = true;
						this.timeErrorTips = '项目截至时间必须大于起始时间'
						return false;
					} else {
						this.timeError = false;
					}
				}

				if(!this.dataSource.duty) {
					this.noDuty = true;
					return false;
				} else {
					this.noDuty = false;
				}

				if(!this.dataSource.performance) {
					this.noPerformance = true;
					return false;
				} else {
					this.noPerformance = false;
				}

				return true;
			},

			//取消对当前项目的编辑的保存
			resumeEducationalBackgroundEditCancel() {
				this.setDataSouce();
				this.$emit('edit-cancel');
			},

			//编辑项目时选择至今
			setEndTimeDisabled() {
				if(this.dataSource.isNotYet) {
					this.dataSource.isNotYet = false;
				} else {
					this.dataSource.isNotYet = true;
					let d = new Date();
					let year = d.getFullYear();
					let month = d.getMonth() + 1;
					this.dataSource.endYear = year.toString();
					this.dataSource.endMonth = month.toString();
				}
			},

			//根据传入的类型设置好本实例的数据
			setDataSouce() {
				if(this.type === 'add') {
					this.dataSource = JSON.parse(JSON.stringify(this.tempObj));
				} else {
					let raw_data = JSON.parse(JSON.stringify(this.tempObj)); //编辑时传递过来的数据需要处理

					this.dataSource.id = raw_data.id;
					this.dataSource.projectName = raw_data.projectName;
					this.dataSource.jobTitle = raw_data.jobTitle;
					this.dataSource.startYear = raw_data.dateFromStr.split(".")[0];
					this.dataSource.startMonth = raw_data.dateFromStr.split(".")[1];
					this.dataSource.endYear = raw_data.dateToStr.split(".")[0];
					this.dataSource.endMonth = raw_data.dateToStr.split(".")[1];
					this.dataSource.isNotYet = raw_data.isCurrent;
					this.dataSource.duty = raw_data.duty.toString().replace(/<br>/g, '\n');
					this.dataSource.performance = raw_data.performance.toString().replace(/<br>/g, '\n');
				}
			},

		} //methods结束
	}
</script>

<style scoped lang='less'>
	@import url("../../assets/css/editResume.less");
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeProjectModal.vue